<script setup lang="ts">
import { useClassStore, useSignalRStore } from '../../stores'
import { computed } from 'vue'
import HandIcon from '../../assets/icons/hand.svg'
import HandCrossIcon from '../../assets/icons/hand-cross.svg'
import Switch from '../Form/Switch.vue'

const classStore = useClassStore()
const signalr = useSignalRStore()

const enabled = computed({
    get: () => classStore.selectedClassDetails?.allowRaiseHand,
    set: (value: boolean) => {
        if (!value) {
            signalr.disableRaiseHand()
            signalr.removeRequestRaiseHand()
            return;
        }
        signalr.allowRaiseHand()
    },
})

// Map icon
const lockIconMap = {
    unlock: HandCrossIcon,
    lock: HandIcon,
}
</script>

<template>
    <Switch v-model="enabled" color="lime">
        <template #label>
            <div class="flex items-center gap-1">
                <component :is="lockIconMap[enabled ? 'lock' : 'unlock']" class="size-6 transition-transform duration-200" />
            </div>
        </template>
    </Switch>
</template>